import { createAuthenticatedRoute } from '@/common/auth';
import { EnterCodePage } from '@/pages/enter-code';

export type EnterCodeRouteProps = {
	code?: string;
};

const validateStringParam = (param: unknown) => param?.toString();

export const Route = createAuthenticatedRoute('/_app/enter-code')({
	component: EnterCodePage,
	validateSearch: (params): EnterCodeRouteProps => {
		return {
			code: validateStringParam(params.code),
		};
	},
});
